/**
 * Shared modal chrome tokens — the single source of truth for how every
 * modal/alert/sheet surface and backdrop looks (Apple-style, mirrors the
 * native apps): borderless white surface on a soft gray translucent dim.
 * Overlay blur is intentionally absent — the blur lives on the surface
 * itself so the underlying UI shows through the panel, not the backdrop.
 */

/** Soft gray dim behind centered dialogs and alerts. */
export const modalOverlayTint = 'bg-foreground/25';

/** Stronger gray dim behind full-height sheets and drawers. */
export const sheetOverlayTint = 'bg-foreground/45';

/**
 * Borderless translucent Liquid Glass surface with heavy backdrop blur and a
 * soft diffuse shadow. Never add a `border` next to this.
 */
export const modalSurface =
  'bg-background/70 backdrop-blur-2xl shadow-[0_40px_240px_-20px_rgba(0,0,0,0.22),0_8px_32px_-12px_rgba(0,0,0,0.08)]';
